import i18n from 'config/i18n';
import { Dayjs } from 'dayjs';
import {
  EmploymentAdditionalPropertyType,
  EmploymentAdditionalPropertyValueIDType
} from 'generated';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    validFrom: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : true)
      )
      .optional(),
    validTo: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : true)
      )
      .test(
        'dayjs-min',
        () =>
          t('dateRangeMismatch', {
            startDate: t('validFrom'),
            endDate: t('validTo')
          }),
        (validTo, ctx) => {
          const validFrom = ctx.parent.validFrom as Dayjs;
          return validTo && validFrom ? validTo.isAfter(validFrom) : true;
        }
      )
      .optional(),
    propertyType: yup
      .mixed<EmploymentAdditionalPropertyType>()
      .test(
        'required',
        () => t('employmentAdditionalPropertyTypeRequired'),
        (v) => !!v
      )
      .required(),
    propertyValue: yup.string().optional(),
    propertyValueIDType: yup
      .mixed<EmploymentAdditionalPropertyValueIDType>()
      .test(
        'required-if-propertyType-is-ID',
        () => t('employmentAdditionalPropertyValueIDTypeRequired'),
        (v, ctx) => {
          const propertyType = ctx.parent
            .propertyType as EmploymentAdditionalPropertyType;
          return propertyType === 'IDENTITY' ? !!v : true;
        }
      ),
    propertyValueAddressLine1: yup.string().nullable().optional(),
    propertyValueAddressLine2: yup.string().nullable().optional(),
    propertyValueAddressLine3: yup.string().nullable().optional(),
    propertyValueAddressLine4: yup.string().nullable().optional(),
    propertyValueAddressLine5: yup.string().nullable().optional()
  });
};

export default getSchema;
